import { prefixObjectValues } from '../utils';

// The button tag is suffixed with the video id (`tutorial-video-button-b2bListing`) so each of the
// placements on a page can be selected on its own.
const tutorialVideo = {
  button: 'button',
  tooltip: 'tooltip',
  video: 'video',
  frame: 'frame',
};

export default prefixObjectValues(tutorialVideo, 'tutorial-video');
